import { BillingTransferRequestStatus } from "@common/constants/domains/billing/billingTransferRequest";
import { billingTransferRequestSchema } from "@common/dto/billing/transfer-request.dto";
import { initContract } from "@ts-rest/core";
import { z } from "zod";

const c = initContract();

export const billingTransferContract = c.router(
    {
        transferToClient: {
            path: "/transfer-to-client",
            method: "POST",
            body: z.object({
                organizationId: z.string(),
                workspaceId: z.string(),
                newPrimaryAdminId: z.number(),
            }),
            responses: {
                200: c.noBody(),
            },
        },
        getPendingTransferRequestsForWorkspace: {
            path: "/pending-requests/:workspaceId",
            method: "GET",
            pathParams: z.object({
                workspaceId: z.string(),
            }),
            responses: {
                200: z.array(
                    z.object({
                        id: z.string(),
                        organizationId: z.string(),
                    }),
                ),
            },
        },
        requestBillingTransferFromClient: {
            path: "/request-from-client",
            method: "POST",
            body: z.object({
                organizationId: z.string(),
                workspaceId: z.string(),
            }),
            responses: {
                201: c.noBody(),
            },
        },
        requestBillingTransferFromOrganization: {
            path: "/request-from-organization",
            method: "POST",
            body: z.object({
                fromOrganizationId: z.string(),
                workspaceId: z.string(),
            }),
            responses: {
                201: c.noBody(),
            },
        },
        getTransferRequestByCode: {
            path: "/request/:requestCode",
            method: "GET",
            pathParams: z.object({
                requestCode: z.string(),
            }),
            responses: {
                200: billingTransferRequestSchema,
            },
        },
        resolveBillingTransferRequest: {
            path: "/resolve",
            method: "POST",
            body: z.object({
                requestId: z.string(),
                status: z
                    .nativeEnum(BillingTransferRequestStatus)
                    .refine(
                        (status) =>
                            status !== BillingTransferRequestStatus.PENDING,
                        {
                            message: "Cannot resolve into a pending state",
                        },
                    ),
            }),
            responses: {
                200: c.noBody(),
            },
        },
        cancelBillingTransferRequest: {
            path: "/:requestId",
            method: "DELETE",
            pathParams: z.object({
                requestId: z.string(),
            }),
            responses: {
                200: c.noBody(),
            },
        },
    },
    {
        pathPrefix: "/billing-transfer",
    },
);
